var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin":"25px"}},[_c('vue-good-table',{attrs:{"columns":_vm.satisListesicolumns,"rows":_vm.gruplananACT,"rtl":_vm.dir,"max-height":"350px","fixed-header":true,"group-options":{
      enabled: true,
    }},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field === 'TRANSDATE')?_c('div',{staticClass:"text-nowrap"},[_c('span',{staticClass:"text-nowrap"},[_vm._v(_vm._s(props.row.TRANSDATE))])]):_vm._e()]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }